import { createContext, useContext, useState } from "react";
import { enumProveedorStep, maxFileSize } from "../settings/enumConfig";
import {
    fnHandleChangeDate,
    fnHandleChangeText,
    fnHandleChangeTextNotError,
    fnHandleChangeTextUpper,
    fnHandleChangeUInteger,
} from "../settings/handleConfig";
import { rxCorreo, rxUrl } from "../settings/regexConfig";

import { apiValidaRFC } from "../settings/apiConfig";
import { getDatePost } from "../settings/convertConfig";
import { getDatosCompaniaForm } from "../model/datosCompaniaModel";
import { useCobertura } from "./CoberturaContext";
import { useEffect } from "react";
import { useProveedoresProspectos } from "./ProveedoresProspectosContext";
import { useRequest } from "./RequestContext";
import { useTipoPersona } from "./TipoPersonaContext";

export const DatosCompaniaContext = createContext();

export const DatosCompaniaProvider = (props) => {
    const { Get } = useRequest();
    const { provedoresSteps, entSolicitudDetalleForEdit, handleChangeProveedoresStep,
        handleClickResetStepError, handleChangeStep, handleExtranjero } =
        useProveedoresProspectos();
    const { listaTipoPersona } = useTipoPersona();
    const { listaCobertura } = useCobertura();

    const [datosCompaniaForm, setDatosCompaniaForm] = useState(getDatosCompaniaForm());
    const [datosCompaniaEnt, setDatosCompaniaEnt] = useState(null);
    const [cartaPresentacionArhivo, setCartaPresentacionArhivo] = useState(null);
    const [constanciaSituacionFiscal, setConstanciaSituacionFiscal] = useState(null);
    const [validarArchivo, setValidarArchivo] = useState(true);
    const [validarArchivoSituacionFiscal, setValidarArchivoSituacionFiscal] = useState(true);
    const [rfcValido, setRfcValido] = useState(null);
    const [rfcValidaMensaje, setRfcValidaMensaje] = useState(null);

    const handleChangeDatosCompaniaText = fnHandleChangeText(datosCompaniaForm, setDatosCompaniaForm);
    const handleChangeDatosCompaniaDate = fnHandleChangeDate(datosCompaniaForm, setDatosCompaniaForm);
    const handleChangeDatosCompaniaUInt = fnHandleChangeUInteger(datosCompaniaForm, setDatosCompaniaForm);
    const handleChangeDatosCompaniaUpper = fnHandleChangeTextUpper(datosCompaniaForm, setDatosCompaniaForm);
    const handleChangeDatosCompaniaNotError = fnHandleChangeTextNotError(datosCompaniaForm, setDatosCompaniaForm);

    const handleChangeDatosCompaniaTextRFC = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setDatosCompaniaForm({
            ...datosCompaniaForm,
            [name]: {
                ...datosCompaniaForm[name],
                value: value,
                // value: typeof value === "string" ? value.toUpperCase() : value,
                error: value === "",
            },
        });
        setRfcValido(null);
        setRfcValidaMensaje(null);
    };

    const handleClickAdjuntarCartaPresentacion = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.value = "";

        input.addEventListener("change", (e) => {
            e.preventDefault();

            let error = false;
            const file = input.files[0];

            if (!file) {
                error = true;
            } else {
                const fileNameSplit = file.name.split(".");
                const extension = fileNameSplit[fileNameSplit.length - 1];

                if ((extension !== "doc" && extension !== "docx" && extension !== "pdf") || file.size > maxFileSize) {
                    error = true;
                } else {
                    setCartaPresentacionArhivo(file);
                    setValidarArchivo(true);
                }
            }

            const { txtCartaPresentacion } = datosCompaniaForm;

            setDatosCompaniaForm({
                ...datosCompaniaForm,
                txtCartaPresentacion: {
                    ...txtCartaPresentacion,
                    value: !error ? file.name : "",
                    error: error,
                },
            });

            if (error) {
                setCartaPresentacionArhivo(null);
            }

            input.remove();
        });

        input.click();
    };

    const handleClickEliminarArchivoCartaPresentacion = () => {
        const { txtCartaPresentacion } = datosCompaniaForm;

        setDatosCompaniaForm({
            ...datosCompaniaForm,
            txtCartaPresentacion: {
                ...txtCartaPresentacion,
                value: "",
                error: false,
            },
        });

        setCartaPresentacionArhivo(null);
    };

    const handleClickAdjuntarConstanciaSituacionFiscal = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.value = "";

        input.addEventListener("change", (e) => {
            e.preventDefault();

            let error = false;
            const file = input.files[0];

            if (!file) {
                error = true;
            } else {
                const fileNameSplit = file.name.split(".");
                const extension = fileNameSplit[fileNameSplit.length - 1];

                if ((extension !== "doc" && extension !== "docx" && extension !== "pdf") || file.size > maxFileSize) {
                    error = true;
                } else {
                    setConstanciaSituacionFiscal(file);
                    setValidarArchivoSituacionFiscal(true);
                }
            }

            const { txtSituacionFiscal } = datosCompaniaForm;

            setDatosCompaniaForm({
                ...datosCompaniaForm,
                txtSituacionFiscal: {
                    ...txtSituacionFiscal,
                    value: !error ? file.name : "",
                    error: error,
                },
            });

            if (error) {
                setConstanciaSituacionFiscal(null);
            }

            input.remove();
        });

        input.click();
    };

    const handleClickEliminarArchivoSituacionFiscal = () => {
        const { txtSituacionFiscal } = datosCompaniaForm;

        setDatosCompaniaForm({
            ...datosCompaniaForm,
            txtSituacionFiscal: {
                ...txtSituacionFiscal,
                value: "",
                error: false,
            },
        });

        setConstanciaSituacionFiscal(null);
    };

    const handleClickDeleteChipCobertura = (cobertura) => {
        const { txtCobertura } = datosCompaniaForm;

        setDatosCompaniaForm({
            ...datosCompaniaForm,
            txtCobertura: {
                ...txtCobertura,
                value: txtCobertura.value.filter((x) => x.iIdCobertura !== cobertura.iIdCobertura),
            },
        });
    };

    const handleClickConfirmarDatosCompania = () => {
        const {
            txtTipoPersona,
            txtNombreContactoPrincipal,
            txtRFC,
            txtTelefonoContactoPrincipal,
            txtRazonSocial,
            txtCorreoContactoPrincipal,
            txtCobertura,
            txtNumeroDUNS,
            txtNumeroEmpleados,
            txtRegistroPatronalIMSS,
            txtFechaConstitucionEmpresa,
            txtCartaPresentacion,
            txtSituacionFiscal,
            txtEstructuraLegal,
            txtSitioWeb,
            txtNombreComercial,
        } = datosCompaniaForm;

        const tempForm = {
            ...datosCompaniaForm,
            txtTipoPersona: {
                ...txtTipoPersona,
                error: !txtTipoPersona.required ? false : txtTipoPersona.value === "",
            },
            txtNombreContactoPrincipal: {
                ...txtNombreContactoPrincipal,
                error: !txtNombreContactoPrincipal.required ? false : txtNombreContactoPrincipal.value === "",
            },
            txtRFC: {
                ...txtRFC,
                error: !txtRFC.required
                    ? false
                    : txtRFC.value === "" ||
                    txtTipoPersona.value === "" ||
                    (txtTipoPersona.value > 1000 && (txtRFC.value.length < 9 || txtRFC.value.length > 18)) ||
                    (txtTipoPersona.value < 1000 && (txtRFC.value.length < 12 || txtRFC.value.length > 13)),
            },
            txtTelefonoContactoPrincipal: {
                ...txtTelefonoContactoPrincipal,
                error: !txtTelefonoContactoPrincipal.required
                    ? false
                    : txtTelefonoContactoPrincipal.value === "" || txtTelefonoContactoPrincipal.value.length < 10,
            },
            txtRazonSocial: {
                ...txtRazonSocial,
                error:
                    !txtRazonSocial.required || (txtTipoPersona.value !== "2" && txtTipoPersona.value !== "1002")
                        ? false
                        : txtRazonSocial.value === "",
            },
            txtCorreoContactoPrincipal: {
                ...txtCorreoContactoPrincipal,
                error: !txtCorreoContactoPrincipal.required
                    ? false
                    : txtCorreoContactoPrincipal.value === "" || !rxCorreo.test(txtCorreoContactoPrincipal.value),
            },
            txtCobertura: {
                ...txtCobertura,
                error: !txtCobertura.required ? false : txtCobertura.value.length === 0,
            },
            txtNumeroDUNS: {
                ...txtNumeroDUNS,
                error: !txtNumeroDUNS.required ? false : txtNumeroDUNS.value === "",
            },
            txtNumeroEmpleados: {
                ...txtNumeroEmpleados,
                error:
                    !txtNumeroEmpleados.required || (txtTipoPersona.value !== "2" && txtTipoPersona.value !== "1002")
                        ? false
                        : txtNumeroEmpleados.value === "",
            },
            txtRegistroPatronalIMSS: {
                ...txtRegistroPatronalIMSS,
                error: !txtRegistroPatronalIMSS.required ? false : txtRegistroPatronalIMSS.value === "",
            },
            txtFechaConstitucionEmpresa: {
                ...txtFechaConstitucionEmpresa,
                error: !txtFechaConstitucionEmpresa.required ? false : !txtFechaConstitucionEmpresa.value,
            },
            txtCartaPresentacion: {
                ...txtCartaPresentacion,
                error: !validarArchivo
                    ? false
                    : !txtCartaPresentacion.required
                        ? false
                        : txtCartaPresentacion.value === "" || !cartaPresentacionArhivo,
            },
            txtSituacionFiscal: {
                ...txtSituacionFiscal,
                error: !validarArchivoSituacionFiscal
                    ? false
                    : !txtSituacionFiscal.required
                        ? false
                        : txtSituacionFiscal.value === "" || !constanciaSituacionFiscal,
            },
            txtSitioWeb: {
                ...txtSitioWeb,
                error: txtSitioWeb.value === "" ? false : !rxUrl.test(txtSitioWeb.value),
            },
            txtNombreComercial: {
                ...txtNombreComercial,
                error:
                    !txtNombreComercial.required || (txtTipoPersona.value !== "1" && txtTipoPersona.value !== "1001")
                        ? false
                        : txtNombreComercial.value === "",
            },
        };

        setDatosCompaniaForm(tempForm);

        if (
            Object.values(tempForm)
                .map((x) => x.error)
                .includes(true) ||
            !!rfcValidaMensaje
        ) {
            handleChangeProveedoresStep(
                provedoresSteps.map((x) => ({ ...x, error: x.id === enumProveedorStep.DatosCompania ? true : false }))
            );
            return;
        } else {
            handleClickResetStepError();
        }

        const iTipoPersona = parseInt(txtTipoPersona.value);

        const sDescripcionTipoPersona = listaTipoPersona.find((x) => x.iIdTipoPersona === iTipoPersona).sDescripcion;

        const entDatosCompania = {
            iTipoPersona: iTipoPersona,
            sDescripcionTipoPersona,
            sNombreContactoPrincipal: txtNombreContactoPrincipal.value,
            sRFC: txtRFC.value,
            sTelefonoContactoPrincipal: txtTelefonoContactoPrincipal.value,
            sRazonSocial: txtTipoPersona.value !== "2" || txtTipoPersona.value !== "1002" ? txtRazonSocial.value : null,
            sCorreoConactoPrincipal: txtCorreoContactoPrincipal.value,
            lstCobertura: txtCobertura.value.map((x) => x.iIdCobertura),
            sNumeroDUNS: txtNumeroDUNS.value,
            iNumeroEmpleados: txtTipoPersona.value !== "2" || txtTipoPersona.value !== "1002" ? parseInt(txtNumeroEmpleados.value) : 0,
            sRegistroPatronalIMSS: txtRegistroPatronalIMSS.value,
            dtFechaConstitucionEmpresa: getDatePost(txtFechaConstitucionEmpresa.value),
            sCartaPresentacionNombreArchivo: txtCartaPresentacion.value,
            sSituacionFiscalNombreArchivo: txtSituacionFiscal.value,
            sEstructuraLegal: txtTipoPersona.value !== "2" || txtTipoPersona.value !== "1002" ? txtEstructuraLegal.value : null,
            sSitioWeb: txtSitioWeb.value,
            sNombreComercial: txtTipoPersona.value !== "1" || txtTipoPersona.value !== "1001" ? txtNombreComercial.value : null,
        };

        setDatosCompaniaEnt(entDatosCompania);

        handleChangeStep(enumProveedorStep.GiroPrincipal);

        handleExtranjero(txtTipoPersona.value === "1001" || txtTipoPersona.value === "1002")

    };

    const handleBlurValidaRFC = async () => {
        const { txtRFC, txtTipoPersona } = datosCompaniaForm;
        if (txtTipoPersona.value > 1000 && (txtRFC.value.length > 18 || txtRFC.value.length < 9)) {
            return;
        }

        if (txtTipoPersona.value < 1000 && (txtRFC.value.length > 13 || txtRFC.value.length < 12)) {
            return;
        }

        const payload = {
            url: apiValidaRFC.replace("{sRFC}", txtRFC.value),
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setRfcValido(true);
            setRfcValidaMensaje(null);
        } else {
            setRfcValido(false);
            setRfcValidaMensaje(response.Message);
        }
    };

    const fnFillFormDatosCompania = () => {
        if (!entSolicitudDetalleForEdit) {
            return;
        }

        const {
            entDatosCompania: {
                iTipoPersona,
                sNombreContactoPrincipal,
                sRFC,
                sTelefonoContactoPrincipal,
                sRazonSocial,
                sCorreoConactoPrincipal,
                lstCoberturas,
                sNumeroDUNS,
                iNumeroEmpleados,
                sRegistroPatronalIMSS,
                dtFechaConstitucionEmpresa,
                sCartaPresentacionNombreArchivo,
                sSituacionFiscalNombreArchivo,
                sEstructuraLegal,
                sSitioWeb,
                sNombreComercial,
            },
        } = entSolicitudDetalleForEdit;

        const lstCoberturaId = lstCoberturas.map((x) => x.iIdCobertura);
        const coberturasSeleccionadas = listaCobertura.filter((x) => lstCoberturaId.includes(x.iIdCobertura));

        const {
            txtTipoPersona,
            txtNombreContactoPrincipal,
            txtRFC,
            txtTelefonoContactoPrincipal,
            txtRazonSocial,
            txtCorreoContactoPrincipal,
            txtCobertura,
            txtNumeroDUNS,
            txtNumeroEmpleados,
            txtRegistroPatronalIMSS,
            txtFechaConstitucionEmpresa,
            txtCartaPresentacion,
            txtSituacionFiscal,
            txtEstructuraLegal,
            txtSitioWeb,
            txtNombreComercial,
        } = datosCompaniaForm;

        setDatosCompaniaForm({
            ...datosCompaniaForm,
            txtTipoPersona: { ...txtTipoPersona, value: !iTipoPersona ? "" : iTipoPersona.toString() },
            txtNombreContactoPrincipal: { ...txtNombreContactoPrincipal, value: !sNombreContactoPrincipal ? "" : sNombreContactoPrincipal },
            txtRFC: { ...txtRFC, value: !sRFC ? "" : sRFC },
            txtTelefonoContactoPrincipal: {
                ...txtTelefonoContactoPrincipal,
                value: !sTelefonoContactoPrincipal ? "" : sTelefonoContactoPrincipal,
            },
            txtRazonSocial: { ...txtRazonSocial, value: !sRazonSocial ? "" : sRazonSocial },
            txtCorreoContactoPrincipal: { ...txtCorreoContactoPrincipal, value: !sCorreoConactoPrincipal ? "" : sCorreoConactoPrincipal },
            txtCobertura: { ...txtCobertura, value: !lstCoberturas ? [] : coberturasSeleccionadas },
            txtNumeroDUNS: { ...txtNumeroDUNS, value: !sNumeroDUNS ? "" : sNumeroDUNS },
            txtNumeroEmpleados: { ...txtNumeroEmpleados, value: !iNumeroEmpleados ? "" : iNumeroEmpleados.toString() },
            txtRegistroPatronalIMSS: { ...txtRegistroPatronalIMSS, value: !sRegistroPatronalIMSS ? "" : sRegistroPatronalIMSS },
            txtFechaConstitucionEmpresa: {
                ...txtFechaConstitucionEmpresa,
                value: !dtFechaConstitucionEmpresa ? new Date() : new Date(dtFechaConstitucionEmpresa),
            },
            txtCartaPresentacion: {
                ...txtCartaPresentacion,
                value: !sCartaPresentacionNombreArchivo ? "" : sCartaPresentacionNombreArchivo,
            },
            txtSituacionFiscal: {
                ...txtSituacionFiscal,
                value: !sSituacionFiscalNombreArchivo ? "" : sSituacionFiscalNombreArchivo,
            },
            txtEstructuraLegal: { ...txtEstructuraLegal, value: !sEstructuraLegal ? "" : sEstructuraLegal },
            txtSitioWeb: { ...txtSitioWeb, value: !sSitioWeb ? "" : sSitioWeb },
            txtNombreComercial: { ...txtNombreComercial, value: !sNombreComercial ? "" : sNombreComercial },
        });
        setValidarArchivo(false);
        setValidarArchivoSituacionFiscal(false);
    };

    useEffect(() => {
        if (entSolicitudDetalleForEdit) {
            fnFillFormDatosCompania();
        }
        // eslint-disable-next-line
    }, [entSolicitudDetalleForEdit]);

    return (
        <DatosCompaniaContext.Provider
            value={{
                datosCompaniaEnt,
                datosCompaniaForm,
                cartaPresentacionArhivo,
                constanciaSituacionFiscal,
                rfcValido,
                rfcValidaMensaje,
                handleClickDeleteChipCobertura,
                handleClickEliminarArchivoCartaPresentacion,
                handleClickEliminarArchivoSituacionFiscal,
                handleChangeDatosCompaniaText,
                handleChangeDatosCompaniaDate,
                handleChangeDatosCompaniaUInt,
                handleChangeDatosCompaniaUpper,
                handleChangeDatosCompaniaNotError,
                handleChangeDatosCompaniaTextRFC,
                handleClickConfirmarDatosCompania,
                handleClickAdjuntarCartaPresentacion,
                handleClickAdjuntarConstanciaSituacionFiscal,
                handleBlurValidaRFC,
            }}
        >
            {props.children}
        </DatosCompaniaContext.Provider>
    );
};

export const useDatosCompania = function () {
    return useContext(DatosCompaniaContext);
};
